const deviceChecker = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  return {
    isIE: () => {
      return /msie|trident/.test(userAgent);
    },
  };
};

export default deviceChecker();
